module.exports = __webpack_public_path__ + "img/star-map_bg-3.5d324a9.png";